import { MetrikaInfoPanel, useLogMount } from '@metrika/ui-kit';
import { InlineLoading } from '@metrika/ui-kit/carbon';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useFlags } from '../_env';
import { useRemoteFlag } from '../_env/unleash';
import { useDashboards } from '../charting/hooks';
import { useIsLogged, useSidebar } from '../user/hooks';
import { HeaderMenu, SidebarMain, MainLoading } from './components';
import { Dots } from './components/SidebarMain/styles';
import { FullPage, StyledContent, StyledContentSidebar } from './components/styles';
import { useSidebarIsExpanded } from './hooks/useSidebarIsExpanded';

export const Layout: React.FC = ({ children }) => {
   useLogMount('Layout');

   const { useDots } = useFlags();

   const { isLogged, isRiskUser } = useIsLogged();

   const { isSideNavExpanded, onClickSideNavExpand, onMainContentClick } = useSidebarIsExpanded();

   const { loading, data } = useSidebar();

   /* preload dashboards */
   useDashboards();
   const offMode = useRemoteFlag('maintenanceOn');
   return (
      <FullPage>
         <HeaderMenu isExpanded={isSideNavExpanded} buttonHandler={onClickSideNavExpand} />
         <Switch>
            <Route path={'/'} exact>
               <Redirect to={'/risk'} />
            </Route>
            <>
               {/* workspaces loading */}
               {loading && <MainLoading />}
               {/* workspaces loaded - sidebar and main content allowed */}
               {!loading && data && data.length > 0 ? (
                  <>
                     <SidebarMain workspaces={data} expanded={isSideNavExpanded} onToggle={onClickSideNavExpand} />
                     <StyledContentSidebar tagName={'main'} onClick={onMainContentClick}>
                        {offMode && (
                           <div style={{ marginBottom: '16px' }}>
                              <MetrikaInfoPanel kind={'warning'}>
                                 We are currently performing system maintenance. Some data may be temporarily out of
                                 sync. We apologize for the inconvenience and appreciate your patience.
                              </MetrikaInfoPanel>
                           </div>
                        )}
                        {useDots && <Dots />}
                        {children}
                     </StyledContentSidebar>
                  </>
               ) : !loading && isLogged && !isRiskUser ? (
                  <StyledContent tagName={'main'}>
                     <MetrikaInfoPanel kind={'error'}>You do not have access to the application.</MetrikaInfoPanel>
                  </StyledContent>
               ) : (
                  <InlineLoading />
               )}
            </>
         </Switch>
      </FullPage>
   );
};
